const urlBuilder = require('civicsUtils/buildUrlParameters');

define(function(){
	const GenericCollection = require('civicsBase/generic_collection');
	var commonId;
	var cdrId;
	return GenericCollection.extend({
		dataTypeContext : [{
			type: 'Related',
			urlRoot: 'cdr/common/applications/{0}/relatedapplications',
			url: function() {
				return this.urlRoot.format(this.commonId);
			}
		}, {
			type: 'Child',
			urlRoot: 'cdr/applications/Project/{0}/children',
			url: function() {
				return this.urlRoot.format(this.cdrId);
			}
		}, {
			type: 'ServiceRequest',
			urlRoot: 'cdr/common/applications/{0}/servicerequests',
			url: function() {
				return this.urlRoot.format(this.commonId);
			},
			fieldMappings: [{
 			 appName: 'applicationDateTime',
 			 svcName: 'requestDate'
 			},{
 			 	appName: 'addedDateTime',
  			 svcName: 'requestDate',
  			 type:'number'
				},{
	 			 appName: 'applicationNumber',
	 			 svcName: 'id',
	 			 type:'number'
	 			},{
	 			 appName: 'ApplicationContacts',
	 			 svcName: ''
	 		 },{
	 			appName: 'ApplicationType',
	 			svcName: 'requestType.type'
 			}]
		},
		{
			disabled:true,
			type: 'Instrument',
			urlRoot: 'portal/instruments',
			url:function(){
				var ret = this.urlRoot;
				if(this.cdrId){
					var parms = urlBuilder.buildUrlParameters({
						filter:{
							property:'Project',
							value:this.cdrId,
							operator:'Equal'
						}
					});
					ret+=parms;
				}
				else if( this.urlParameters){
					ret += urlBuilder.buildUrlParameters(this.urlParameters)
				}
				return ret;
			}
		}]
	});
});
